import { Reveal, SectionHeader } from "./Reveal";
import { Download, FileText, Mail } from "lucide-react";

export const Press = () => (
  <section id="prensa" className="relative py-24 sm:py-32 bg-coal/40">
    <div className="mx-auto max-w-[1600px] px-6 sm:px-12 lg:px-24">
      <SectionHeader
        eyebrow="Prensa"
        title={
          <>
            Material oficial para <span className="italic text-gold">medios</span>.
          </>
        }
      />

      <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-7">
          <Reveal>
            <blockquote data-testid="press-quote" className="border-l-2 border-gold/60 pl-6 md:pl-10">
              <p className="font-serif italic text-2xl md:text-4xl leading-snug text-cream text-balance">
                “«Con un solo corazón» es mucho más que un espectáculo; es un viaje al alma de Cuarto Bolero, un reencuentro con casi 30 años de historia contados a través de las canciones que han marcado generaciones.”
              </p>
              <cite className="mt-6 block text-xs uppercase tracking-[0.3em] text-gold not-italic">Dossier de prensa oficial</cite>
            </blockquote>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-10 max-w-2xl text-base md:text-lg leading-relaxed text-sand">
              En cada acorde resuena el eco de noches inolvidables, de amores que fueron y de sueños que aún persisten en el tiempo. La nostalgia se convierte en protagonista y el corazón late al compás de los recuerdos.
            </p>
          </Reveal>
        </div>

        <div className="md:col-span-5">
          <Reveal delay={0.1}>
            <div className="border border-gold/20 bg-card p-8 md:p-10" data-testid="press-kit-card">
              <FileText className="text-gold" size={30} strokeWidth={1.5} />
              <h3 className="mt-5 font-serif text-2xl md:text-3xl text-cream">Dossier de prensa</h3>
              <p className="mt-3 text-sm leading-relaxed text-sand">
                Biografía, discografía, formación y rider técnico del grupo en un único documento oficial (PDF).
              </p>
              <a
                data-testid="press-kit-download"
                href="/press-kit/DOSSIER_CUARTO_BOLERO.pdf"
                download="CUARTO_BOLERO_Dossier.pdf"
                className="mt-7 inline-flex items-center gap-3 rounded-full bg-gold px-7 py-3 text-[12px] font-medium uppercase tracking-[0.18em] text-ink transition-all duration-300 hover:shadow-[0_10px_40px_rgba(212,175,55,0.3)]"
              >
                <Download size={15} /> Descargar dossier
              </a>
              <p className="mt-8 text-xs text-mute flex flex-wrap items-center gap-2">
                <Mail size={13} className="text-gold/70" />
                Acreditaciones y material gráfico:
                <a className="text-sand underline decoration-gold/50 underline-offset-4 hover:text-gold transition-colors" href="mailto:eventos@produccionessibemol.es" data-testid="press-email-link">
                  eventos@produccionessibemol.es
                </a>
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
